import { createFileRoute } from '@tanstack/react-router';

import { CatalogEnrichmentLayout } from '~/features/catalog-enrichment/components/catalog-enrichment-layout';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

/**
 * Catalog Enrichment section — the redesigned catalog screens on agentic-catalog-service, a
 * module separate from catalog-v2. Not flag-gated: open to every tenant user. See
 * docs/catalog-enrichment.md.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment')({
  component: () => (
    <RequireChannelConnection>
      <CatalogEnrichmentLayout />
    </RequireChannelConnection>
  ),
});
